module.exports = __webpack_public_path__ + "static/media/pay_payfix.9bd01d43.svg";